import React from 'react';

import Icon from '@components/icon/Icon.tsx';
import Link from '@components/link/Link.tsx';
import getCurrentPage from '@functions/getCurrentPage.ts';
import handlerPopup from '@functions/handlerPopup.ts';

import I from '../types.ts';

const renderContent: I['renderContent'] = function () {
    const { storePages, handlerMenu } = this.props;
    const nav = this.getNav();
    const currentPage = getCurrentPage({
        storePages,
        filter: (page) => page.parentName === 'public',
    });

    return (
        <div className="publicMobileMenu__content _COL _CENTER">
            <div className="publicMobileMenu__nav">
                {nav.map((item) => (
                    <div
                        className={`publicMobileMenu__navItem _col ${
                            currentPage === item.name ? '_current' : ''
                        }`}
                        key={item.name}
                    >
                        <Link
                            className="publicMobileMenu__navLink"
                            pageName={item.name}
                            forceChangePage=".public__page"
                            callback={() => {
                                handlerMenu(false);
                            }}
                        >
                            {item.contentOfLink}
                        </Link>
                    </div>
                ))}
            </div>
            <div
                className="publicMobileMenu__call _ROW _CLICK"
                onClick={() => {
                    handlerPopup('callPopup', {
                        isShow: true,
                    });
                    handlerMenu(false);
                }}
            >
                <i className="publicMobileMenu__callIcon">
                    <Icon name="public-call-button" />
                </i>
                Перезвоните мне
            </div>
        </div>
    );
};

export default renderContent;
